module.exports = __webpack_public_path__ + "static/media/no-permission.04790986.svg";